import { IState } from 'legacy/lut/store'
import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { refreshActionTransitions } from 'onboarding/features/actions/refreshActionTransitions'
import { actionTransitionApi } from 'onboarding/features/api/actionTransitionApi'

listenerMiddleware.startListening({
  actionCreator: refreshActionTransitions,
  effect: async (_action, listenerEffectAPI) => {
    const { dispatch, getState } = listenerEffectAPI
    const state = getState() as IState
    const requestId = state.onboarding.requestData.data.EntryId

    if (requestId) {
      dispatch(actionTransitionApi.getActionTransitions({ requestId: requestId.toString() }))
    }
  },
})
